import {Editable} from "@main/components/elementsEditor/Editable";

$(function(){
    $(".js-element-editable").each(function(){
        let editor = new Editable($(this));
        editor.enable();
    });
});
